import React, {ChangeEvent, Component, FormEvent} from 'react';
import {connect} from 'react-redux';

import {ActionCreatorType, ApplicationStoreType, VoidFunctionType} from 'constants/flow/flowTypes';

import Input from 'components/__helpers/input/input';
import Error from 'components/__helpers/error/error';
import {ValidationAuthorizationLogin} from 'libs/validation/validationField';
import {setCustomerEmail} from 'reducers/analytics/dataLayer';
import {getCustomer, getToken} from 'reducers/oAuth/oAuth';

import style from './login.scss';

type PropsType = {
    visibleTabHandler: VoidFunctionType<string>;
    getToken: (email: string, password: string, type: 'login') => void;
    setCustomerEmail: ActionCreatorType<string>;
    error: string;
};

type StateType = {
    email: string;
    password: string;
};

/**
 * Login authorization component
 */
export class Login extends Component<PropsType, StateType> {
    state = {
        email: '',
        password: '',
    };

    /**
     * Returns validator by field name
     *
     * @param {string} fieldName - Name of field for validation
     * @returns {function} - Field validator
     */
    getValidator = (fieldName: string): VoidFunctionType => () =>
        new ValidationAuthorizationLogin(this.state).one(fieldName);

    /**
     * Change handler input
     * @param {ChangeEvent<HTMLInputElement>} event - Event object
     */
    changeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;

        this.setState({[name]: value} as Pick<StateType, keyof StateType>);
    };

    /**
     * Function handle for submit
     * @param {Event} e - JS event
     */
    handleSubmit = (e: FormEvent<HTMLButtonElement>) => {
        e.preventDefault();
        this.props.getToken(this.state.email, this.state.password, 'login');
    };

    /**
     * Send email to dataLayer
     */
    sendEmailToDataLayer = () => {
        this.props.setCustomerEmail(this.state.email);
    };

    /**
     * Render jsx to html
     * @returns {Node} Rendered react component
     */
    render() {
        const {visibleTabHandler, error} = this.props;
        return (
            <div>
                <div className={style.methods}>
                    <form data-test-name="loginForm">
                        <div className={style.inputBlock} data-test-name="email">
                            <Input
                                type="email"
                                onChange={this.changeHandler}
                                onBlur={this.sendEmailToDataLayer}
                                value={this.state.email}
                                label="Your Email Address"
                                id="email"
                                name="email"
                                validation={this.getValidator('email')}
                            />
                        </div>
                        <div className={style.inputBlock} data-test-name="password">
                            <Input
                                type="password"
                                onChange={this.changeHandler}
                                value={this.state.password}
                                label="Password"
                                id="password"
                                name="password"
                                validation={this.getValidator('password')}
                            />
                        </div>
                        <button
                            type="submit"
                            data-test-name="submit"
                            className={style.submit}
                            onClick={this.handleSubmit}
                        >
                            Login
                        </button>
                        <Error error={error} />
                        <span
                            role="button"
                            className={style.formSwitcher}
                            onClick={() => visibleTabHandler('forgot')}
                        >
                            Forgot your password?
                        </span>
                    </form>
                </div>
            </div>
        );
    }
}

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
export const mapStateToProps = (store: ApplicationStoreType) => ({
    error: getCustomer(store).error || '',
});

export const mapDispatchToProps = {
    getToken,
    setCustomerEmail,
};

export const LoginConnected = connect(mapStateToProps, mapDispatchToProps)(Login);
